import { useLDClient } from "launchdarkly-react-client-sdk";
import { getStaticFlagValues } from "@hooks/useTypedFlags";

/** Every boolean flag's value before any demo override: the static flags when set, else LaunchDarkly's. */
export const useBaseFlagValues = (): Record<string, boolean> => {
    const ldClient = useLDClient();
    const staticFlagValues = getStaticFlagValues();
    if (staticFlagValues) {
        return staticFlagValues;
    }
    return Object.fromEntries(
        Object.entries(ldClient?.allFlags() ?? {}).filter(
            (entry): entry is [string, boolean] =>
                typeof entry[1] === "boolean",
        ),
    );
};
